import {action, query} from "@solidjs/router";
import {CreateClass, UpdateClass} from "@gs-yoga/sdk/types";
import sdk from "~/sdk/sdk";
import {ApiError} from "~/sdk/error";
import {SearchParamsOption} from "ky";

export const getClasses = query(async (params: SearchParamsOption) => {
    try {
        return await sdk().classes.list(params).json()
    } catch (e) {
        throw new ApiError("Failed to get classes", e)
    }
}, "getClasses")

export const getClass = query(async (id: string) => {
    try {
        return await sdk().classes.get(id).json()
    } catch (e) {
        throw new ApiError("Failed to get class", e)
    }
}, "getClass")

export const createClass = action(async (req: CreateClass) => {
    try {
        return await sdk().classes.create(req).json()
    } catch (e) {
        throw new ApiError("Failed to create class", e)
    }
})

export const updateClass = action(async (params: { id: string, req: UpdateClass }) => {
    try {
        const {id, req} = params
        return await sdk().classes.update(id, req).json()
    } catch (e) {
        throw new ApiError("Failed to update class", e)
    }
})
